import React, { useState } from "react";
import { Button, Row, Col, Space, Checkbox, Alert, Divider } from "antd";
import { CheckCircleOutlined, FileTextOutlined } from "@ant-design/icons";
import styles from "./FinalReview.module.css";
import { RootState } from "../../../../store/store";
import { useSelector } from "react-redux";
import RightSideFilePreview from "./RightSideFilePreview";
import uploadStyles from "./UploadJustification.module.css";

interface IFinalReviewProps {
  onSubmit?: any;
  onCancel?: () => void;
  onSaveDraft?: any;
  caseInfo?: {
    caseId?: string;
    patientName?: string;
  };
  isSaving: boolean;
  isSubmitting: boolean;
  handleSubmitAnnexure: any;
  uploadedDocuments?: any;
  documentTypes?: any;
  activeKey: any;
  setUploadedDocuments: any;
  groupDocumentsByType?: any;
  isLastUnlistedProcedureCompleted: boolean;
}

const FinalReview: React.FC<IFinalReviewProps> = ({
  onSubmit,
  onCancel,
  onSaveDraft,
  caseInfo = {
    caseId: "CASE #882-104",
    patientName: "MAHIMA SHARMA",
  },
  handleSubmitAnnexure,
  isSaving,
  isSubmitting,
  documentTypes,
  uploadedDocuments,
  setUploadedDocuments,
  groupDocumentsByType,
  activeKey,
  isLastUnlistedProcedureCompleted
}) => {
  const [verificationChecks, setVerificationChecks] = useState({
    digitalSignature: true,
    doctorSignature: true,
    hospitalStamp: true,
  });
  const [acknowledgeSubmission, setAcknowledgeSubmission] = useState(false);
  const { auth } = useSelector((state: RootState) => state);

  const allChecksPass =
    verificationChecks.digitalSignature &&
    verificationChecks.doctorSignature &&
    verificationChecks.hospitalStamp;

  const handleCheckChange = (key: string) => {
    setVerificationChecks((prev: any) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className={styles.finalReviewContent}>
      {/* <div className={styles.finalReviewHeader}>
        <p className={styles.finalReviewSubtitle}>
          {caseInfo.caseId} • PATIENT: {caseInfo.patientName}
        </p>
      </div> */}

      <Row gutter={[16, 16]} style={{height: "90vh"}}>
        {documentTypes
          ?.filter((docType: any) =>
            docType?.label
              ?.toLowerCase()
              ?.includes("Annexture Document for Portal"?.toLowerCase()),
          )
          ?.map((docType: any) => (
            <Col xs={24} sm={24} md={14}>
              <div className={uploadStyles.uploadJustificationSection}>
                <div className={uploadStyles.uploadJustificationLabel}>
                  {docType?.label
                    ?.toLowerCase()
                    ?.includes("Annexture Document for Portal"?.toLowerCase())
                    ? "Annexure Letter"
                    : docType?.label}
                  <span className={uploadStyles.uploadJustificationRequired}>
                    *
                  </span>
                  <span className={uploadStyles.uploadJustificationBadge}>
                    REQUIRED
                  </span>
                </div>

                {groupDocumentsByType(uploadedDocuments)?.[docType?.labelId]
                  ?.length > 0 ? (
                  <RightSideFilePreview
                    documents={
                      groupDocumentsByType(uploadedDocuments)?.[
                        docType?.labelId
                      ]
                    }
                    activeKey={activeKey}
                    setUploadedDocuments={setUploadedDocuments}
                    uploadedDocuments={uploadedDocuments}
                  />
                ) : (
                  <div
                    className={uploadStyles.uploadJustificationBoxNoDocument}
                  >
                    No Document Uploaded
                  </div>
                )}
              </div>
            </Col>
          ))}
        {/* <Col xs={24} sm={24} md={14}>
          <div className={styles.finalReviewDocumentSection}>
            <h3 className={styles.finalReviewSectionTitle}>Annexure Preview</h3>

            <div className={styles.finalReviewDocumentPreview}>
              <div className={styles.finalReviewDocumentHeader}>
                <FileTextOutlined className={styles.finalReviewDocIcon} />
                <span className={styles.finalReviewDocName}>
                  Annexure_Signed.pdf
                </span>
              </div>

              <div className={styles.finalReviewPreviewPlaceholder}>
                <div className={styles.finalReviewSignatureInfo}>
                  <CheckCircleOutlined className={styles.finalReviewVerifiedIcon} />
                  <p className={styles.finalReviewSignatureStatus}>DIGITAL SIGNATURE VERIFIED</p>
                </div>
              </div>

              <div className={styles.finalReviewPreviewControls}>
                <Button type="text" size="small">
                  100%
                </Button>
              </div>
            </div>
            
          </div>
        </Col> */}

        <Col xs={24} sm={24} md={10}>
          <div className={styles.finalReviewVerificationSection}>
            <h3 className={styles.finalReviewSectionTitle}>
              Verification Checklist
            </h3>
            <p className={styles.finalReviewSectionDescription}>
              QUALITY CONTROL (QC)
            </p>

            <div className={styles.finalReviewChecklist}>
              <div className={styles.finalReviewCheckItem}>
                <Checkbox
                  checked={true}
                  onChange={() => handleCheckChange("digitalSignature")}
                >
                  <span className={styles.finalReviewCheckLabel}>
                    Digital Signature Verified
                  </span>
                </Checkbox>
              </div>
              {/* <div className={styles.finalReviewCheckItem}>
                <Checkbox
                  checked={verificationChecks.doctorSignature}
                  onChange={() => handleCheckChange("doctorSignature")}
                >
                  <span className={styles.finalReviewCheckLabel}>
                    Doctor's Sign Present
                  </span>
                </Checkbox>
              </div>
              <div className={styles.finalReviewCheckItem}>
                <Checkbox
                  checked={verificationChecks.hospitalStamp}
                  onChange={() => handleCheckChange("hospitalStamp")}
                >
                  <span className={styles.finalReviewCheckLabel}>
                    Hospital Stamp Visible
                  </span>
                </Checkbox>
              </div> */}
            </div>

            <Divider />

            <Alert
              message="Final Review Required"
              description="Ensure all fields are legible and matching the source document. Once submitted, the annexure cannot be edited until processed by ECHS."
              type="info"
              showIcon
            />

            <div className={styles.finalReviewSubmitBox}>
              <Checkbox
                checked={true}
                onChange={(e) => setAcknowledgeSubmission(e.target.checked)}
              >
                <span className={styles.finalReviewSubmitText}>
                  I confirm all documents are complete and ready for submission
                  to ECHS Portal.
                </span>
              </Checkbox>
            </div>
          </div>
        </Col>
      </Row>

      <div className={styles.finalReviewActionButtons}>
        <Space>
          {onCancel && (
            <Button size="large" onClick={onCancel}>
              Back to History
            </Button>
          )}
          {onSaveDraft && !isLastUnlistedProcedureCompleted && (
            <Button
              size="large"
              loading={isSaving}
              onClick={() => handleSubmitAnnexure(false)}
              style={{ background: "#F1F5F9", color: "#00549e" }}
            >
              Save Draft
            </Button>
          )}
          {auth?.role?.role !== "FO_STAFF" && !isLastUnlistedProcedureCompleted && (
            <Button
              type="primary"
              size="large"
              loading={isSubmitting}
              // disabled={!allChecksPass || !acknowledgeSubmission}
              onClick={() => handleSubmitAnnexure(true)}
              style={{ background: "#00549E", color: "white" }}
            >
              Submit to ECHS Portal
            </Button>
          )}
        </Space>
      </div>
    </div>
  );
};

export default FinalReview;
